import React from 'react'
import {Icon} from '@chakra-ui/react'
const CrossIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path d="M7.01367 17.4028V7.01392H17.4026" stroke="currentColor" strokeWidth="3" />
            <path d="M7.01367 7.01392L17.4026 17.4028" stroke="currentColor" strokeWidth="3" />
            <path d="M32.9856 22.5972V32.9861H22.5967" stroke="currentColor" strokeWidth="3" />
            <path d="M32.9856 32.9861L22.5967 22.5972" stroke="currentColor" strokeWidth="3" />
            <path d="M32.9856 17.4028V7.01392H22.5967" stroke="currentColor" strokeWidth="3" />
            <path d="M32.9856 7.01392L22.5967 17.4028" stroke="currentColor" strokeWidth="3" />
            <path d="M7.01367 22.5972V32.9861H17.4026" stroke="currentColor" strokeWidth="3" />
            <path d="M7.01367 32.9861L17.4026 22.5972" stroke="currentColor" strokeWidth="3" />
        </Icon>
    )
}

export default CrossIcon
